module.exports = __webpack_public_path__ + "static/media/metronome-black.bfefca5b.png";